"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/ScheduleTab/ScheduleSection/EditScheduleModal/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');
var _reactredux = require('react-redux');





var _schedule = require('shared/validation/team/autoReply/schedule');
var _utils = require('../utils');

var _team = require('shared/selectors/team');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _hooks = require('web/services/hooks');
var _TimeTable = require('./TimeTable'); var _TimeTable2 = _interopRequireDefault(_TimeTable);








const scheduleHelperMessage = 'Set both times for a day, or leave both as None.'

const getScheduleErrorMessage = (
  errors,
) => {
  const scheduleErrors = errors.autoReplyTeamHours
  if (!Array.isArray(scheduleErrors)) return undefined

  return _optionalChain([scheduleErrors, 'access', _ => _.find, 'call', _2 => _2(error => typeof _optionalChain([error, 'optionalAccess', _3 => _3.message]) === 'string'), 'optionalAccess', _4 => _4.message])
}

const EditScheduleModal = ({
  isOpen,
  onClose,
  teamKey,
  onSubmit,
}) => {
  const timezone = _hooks.useAppSelector.call(void 0, 
    state => _optionalChain([_team.selectTeamByKey.call(void 0, state, teamKey), 'optionalAccess', _5 => _5.AutoReplyTimeZone]) || null,
  )
  const teamHours =
    _hooks.useAppSelector.call(void 0, state => _team.selectTeamHoursList.call(void 0, state, teamKey), _reactredux.shallowEqual)
  const defaultValues =
    _react.useMemo.call(void 0, () => _utils.makeDefaultValues.call(void 0, timezone, teamHours), [timezone, teamHours])

  const { control, handleSubmit, formState, reset } =
    _reacthookform.useForm({
      mode: 'onChange',
      resolver: _schedule.autoReplyScheduleResolver,
      defaultValues,
    })

  // The modal stays mounted while closed, so each opening starts from the
  // team's current hours; an update while it is open keeps the admin's edits.
  const wasOpen = _react.useRef.call(void 0, false)
  _react.useEffect.call(void 0, () => {
    if (isOpen && !wasOpen.current) reset(defaultValues)
    wasOpen.current = isOpen
  }, [isOpen, defaultValues, reset])
  const { isValid, isDirty, isSubmitting, errors } = formState
  const scheduleErrorMessage = getScheduleErrorMessage(errors)

  const submit = _react.useCallback.call(void 0, 
    (data) => onSubmit(data).then(onClose),
    [onSubmit, onClose],
  )

  return (
    _react2.default.createElement(_Modal2.default, {
      title: "Edit hours" ,
      isOpen: isOpen,
      onClose: onClose,
      className: "team-page--edit-schedule-modal", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}

      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Time Zone" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}
        , _react2.default.createElement(_Form.SimpleSelectController, {
          name: "autoReplyTimezone",
          control: control,
          options: _utils.tzOptions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
        )
      )
      , _react2.default.createElement('div', {
        className: _classBuilder2.default.call(void 0, 
          'team-page--edit-schedule-modal--status',
          scheduleErrorMessage && 'team-page--edit-schedule-modal--status--error',
        ),
        'aria-live': "polite", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}

        ,  scheduleErrorMessage || scheduleHelperMessage 
      )
      , _react2.default.createElement(_Form.InputSectionWrapper, { shouldCaptureFocus: false, __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
        , _react2.default.createElement(_TimeTable2.default, { control: control, __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}} )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: "Save",
        onPrimaryBtnClick: handleSubmit(submit),
        isPrimaryLoading: isSubmitting,
        isPrimaryEnabled: isValid && isDirty && !isSubmitting,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, EditScheduleModal)
